import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

let modules = [];

let requireModule = require.context("@/pages", true, /router.js$/);
requireModule.keys().forEach((filename) => {
  let module = requireModule(filename);
  let router = Object.values(module.default || module);
  modules = [...modules, ...router];
});

function createRouter() {
  return new VueRouter({
    mode: "hash", 
    routes: [
      {
        path: "/",
        component: () => import("@/App.vue"),
        children: modules,
      },
    ],
  });
}

const router = createRouter();

router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (userInfo) {
    store.commit("user/setUserInfo", userInfo);
  }

  if (to.name !== "login" && !userInfo) {
    router.push({ path: "/login" });
    next();
    return;
  }

  if (!to.name) {
    router.push({
      path: "/index",
    });
    next();
    return;
  }

  next();
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title =
      (store.state.user.companyInfo
        ? store.state.user.companyInfo.title + "-"
        : "") + to.meta.title;
  }
});

export default router;
